// extracted by mini-css-extract-plugin
export const articleContainer = "highlight-module--article-container--1ZGZm";
export const article = "highlight-module--article--159CU";
export const metadataRow = "highlight-module--metadataRow--3Bzo1";
export const authorStuff = "highlight-module--authorStuff--Dcxq1";